<template>
    <div>
        <hero></hero>
        <movie-card-deck classes="mt--300"></movie-card-deck>
        <call-to-action outside gradient="success" title="Ajude-me a completar meu acervo" text="Acesse a página com os filmes que procuro: caso tenha alguma dublagem, entre em contato!" button-title="Veja agora" button-route="/filmes-que-procuro"></call-to-action>
        <call-to-action outside invert gradient="primary" title="Minhas Autorações" text="São os filmes onde a sincronia da dublagem e a inserção no DVD original foram feitas por mim. Que tal conferir meu acervo de autoração própria?" button-title="Acessar Títulos" button-route="/filmes?origem=301"></call-to-action>
    </div>
</template>
<script>

import Hero from "./components/Hero";
import MovieCardDeck from "@/layout/components/Catalog/MovieCardDeck";
import CallToAction from "@/layout/components/Catalog/CallToAction";

export default {
  name: "components",
  components: {
    Hero,
    MovieCardDeck,
    CallToAction
  },
  created() {
    this.axios.get('/v1/mensagem')
      .then(response => {
        if ( response.data.mensagem ) {
          let messageModal =  {
            title: 'Aviso',
            body: response.data.mensagem,
            classe: '',
            icon: 'fa fa-info-circle',
            okButton: 'OK',
            okType: 'primary'
          };
          this.$store.dispatch('modal/invokeStateModal', messageModal);
        }
      })
  }
};
</script>
<style>
</style>
